import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Myaccount } from "./myaccount.interface";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class MyAccountService {
  private http = inject(HttpClient);

  readonly apiUrl = environment.newApiUrl;
  private prefix = `${this.apiUrl}/billing`;

  getDetails() {
    return this.http.get<Myaccount.BillingDetails>(`${this.prefix}/details`);
  }

  getBillingContacts() {
    return this.http.get<Myaccount.BillingContactResult>(
      `${this.prefix}/contacts`,
    );
  }

  createBillingContact(contact: Omit<Myaccount.BillingContact, "id">) {
    return this.http.post<{ status: "success" | "error" }>(
      `${this.prefix}/contacts`,
      contact,
    );
  }

  updateBillingContact(
    id: number,
    contact: Omit<Myaccount.BillingContact, "id">,
  ) {
    return this.http.put<{ status: "success" | "error" }>(
      `${this.prefix}/contacts/${id}`,
      contact,
    );
  }

  deleteBillingContact(id: number) {
    return this.http.delete<{ status: "success" | "error" }>(
      `${this.prefix}/contacts/${id}`,
    );
  }

  updateDetails(details: Myaccount.BillingDetails) {
    return this.http.put<{ status: boolean }>(
      `${this.prefix}/details`,
      details,
    );
  }

  getWHMCSUrlFor(to: string, lang: string) {
    return this.http
      .post<{ url: string }>(`${this.prefix}/whmcs-redirect`, {
        to,
        lang,
      })
      .pipe(map(({ url }) => url));
  }
}
